import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-view-branch-peak-timings-component',
  templateUrl: './view-branch-peak-timings-component.component.html',
  styleUrls: ['./view-branch-peak-timings-component.component.scss']
})
export class ViewBranchPeakTimingsComponentComponent {


  constDaysList = [
    { value: 'SUN', viewValue: 'Sunday' },
    { value: 'MON', viewValue: 'Monday' },
    { value: 'TUE', viewValue: 'Tuesday' },
    { value: 'WED', viewValue: 'Wednesday' },
    { value: 'THU', viewValue: 'Thursday' },
    { value: 'FRI', viewValue: 'Friday' },
    { value: 'SAT', viewValue: 'Saturday' },
  ]

  dayType = [
    { value: 'PEAK_TIME', viewValue: 'Peak Time' },
    { value: 'OFF_PEAK_TIME', viewValue: 'Off Peak Time' },
  ]

  branchPeakTimings = []
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
  }

  ngOnInit() {
    this.branchPeakTimings = this.data.branchPeakTimings;

    this.branchPeakTimings.forEach(element => {
      if (element.start_time != null) {
        element.start_time = this.convertToIst(element.start_time);
      }
      if (element.end_time != null) {
        element.end_time = this.convertToIst(element.end_time);
      }
    });
    this.sortTimeSlots()
  }

  convertToIst(date: any) {
    const timeString = date;
    const time = new Date(`2000-01-01T${timeString}`);
    const formattedTime = time.toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
    return formattedTime;
  }

  sortTimeSlots() {
    let daysListInOrder = []
    this.constDaysList.forEach(elem => {
      if (!daysListInOrder.includes(elem.value)) {
        daysListInOrder.push(elem.value)
      }
    })
    this.branchPeakTimings = this.branchPeakTimings.sort(
      (a, b) => (daysListInOrder.indexOf(a.day_of_week) < daysListInOrder.indexOf(b.day_of_week)) ? -1 : (daysListInOrder.indexOf(a.day_of_week) > daysListInOrder.indexOf(b.day_of_week)) ? 1 : 0
    ).sort(
      (a, b) => {
        if (((daysListInOrder.indexOf(a.day_of_week) < daysListInOrder.indexOf(b.day_of_week)) ? -1 : (daysListInOrder.indexOf(a.day_of_week) > daysListInOrder.indexOf(b.day_of_week)) ? 1 : 0) == 0 && a.day_type=='WORK_DAY') {
          var nowDate = new Date().toISOString().split('T')[0];
          let aZone = a.start_time.slice(-3,)
          let bZone = b.start_time.slice(-3,)
          
          var astartTime = new Date(nowDate + ' ' + a.start_time.slice(0,-2));
          var bstartTime = new Date(nowDate + ' ' + b.start_time.slice(0,-2));
          // console.log(astartTime, bstartTime)
  
          if (aZone == bZone) {
            return (astartTime < bstartTime) ? -1 : (astartTime > bstartTime) ? 1 : 0
          } else if (aZone == 'PM' && bZone == 'AM') {
            return 1
          } else if (aZone == 'AM' && bZone == 'PM') {
            return -1
          }
        }
      }
    )
  }

}
